import React from 'react';
import { translate } from '@fiverr-private/i18n-react';
import pathfinder from '@fiverr-private/pathfinder';
import { EllipsisSolidIcon } from '@fiverr-private/icons';
import { COPIES_PREFIX } from '../../constants';
import { DropdownMenu } from '../../DropdownMenu';
import { IconButton } from '../../IconButton';
import classes from './TouchDropdown.module.scss';

interface TouchDropdownProps {
  sellerUserName: string;
  gigSlug: string;
  onGigLinkClick: () => void;
  onSellerLinkClick: () => void;
}

export const TouchDropdown = ({ sellerUserName, gigSlug, onGigLinkClick, onSellerLinkClick }: TouchDropdownProps) => {
  const menuItems = [
    {
      id: 'see_gig',
      name: translate(`${COPIES_PREFIX}.see_gig`),
      onClick: () => {
        window.open(pathfinder('gig_page', { username: sellerUserName, slug: gigSlug }));
        onGigLinkClick();
      },
    },
    {
      id: 'about_the_seller',
      name: translate(`${COPIES_PREFIX}.about_the_seller`),
      onClick: () => {
        window.open(pathfinder('seller_page', { username: sellerUserName }));
        onSellerLinkClick();
      },
    },
  ];

  return (
    <DropdownMenu
      menuItems={menuItems}
      menuClassName={classes.ellipsisMenu}
      menuItemClassName={classes.ellipsisMenuItem}
      trigger={
        <IconButton transparent>
          <EllipsisSolidIcon size={16} />
        </IconButton>
      }
    />
  );
};
